// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"9536e4c8","453":"8701dc61","455":"6a5e7743","501":"654eb012","670":"81acaa49","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};